"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopSponsorMid = exports.PopSponsorPerkBtn = exports.PopSponsorBtnDisclaimer = exports.PopSponsorBtn = exports.PopButton = exports.PopSponsorActions = exports.PopSponsorPerk = exports.PopSponsorBio = exports.PopSponsorTitle = exports.PopSponsorLogo = exports.PopSponsorTop = exports.PopSponsor = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SpeakerCard = require("./SpeakerCard.styled");

var _SponsorCard = require("./SponsorCard");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  min-height: calc(\n    var(--sideSpacing) + ", "px + var(--sideSpacing)\n  );\n  padding: var(--sideSpacing) calc(254px + var(--sideSpacing))\n    var(--sideSpacing) var(--sideSpacing);\n\n  @media only screen and (max-width: 599px) {\n    padding: var(--sideSpacing);\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n\n  border: 2px solid transparent;\n  color: var(--color-brand, #fff);\n  font-size: 14px;\n  position: relative;\n  display: flex;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -webkit-backface-visibility: hidden;\n  transform: translateZ(0) perspective(1px);\n  backface-visibility: hidden;\n  border-radius: 5px;\n\n  &:after {\n    transition: 0.2s all ease;\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -2;\n    background: var(--color-brand, #fff);\n    animation: AnimationName 5s linear infinite;\n  }\n\n  &:before {\n    transition: 0.2s all ease;\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -1;\n    border-radius: 3px;\n    background: #161917;\n    animation: AnimationName 5s linear infinite;\n  }\n\n  &:hover {\n    color: #000;\n    background: #fff;\n\n    &:after,\n    &:before {\n      opacity: 0;\n      background: #fff;\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  font-size: 12px;\n  color: #fff;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n\n  ", "\n\n  ", "\n\n  &:not(:first-child) {\n    margin: 10px 0 0;\n  }\n\n  @media only screen and (max-width: 1200px) {\n    padding: 15px 20px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-align: center;\n  background-color: var(--color-brand, #fff);\n  padding: 15px 20px;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--color-popup-button-text, #000);\n  text-decoration: none;\n  transition: all ease 0.3s;\n\n  &:hover {\n    background-color: var(--color-brand-hover, #f0f0f0);\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 224px;\n  position: absolute;\n  right: var(--sideSpacing);\n  top: calc(100% + var(--sideSpacing));\n\n  @media only screen and (max-width: 599px) {\n    position: relative;\n    right: auto;\n    margin: 50px auto 0;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  border-top: 2px solid #2e2e2c;\n  padding-top: 20px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--color-popup-general-text, #888);\n  line-height: 1.46;\n\n  a {\n    text-decoration: underline;\n    color: var(--color-popup-title, #fff);\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 28px;\n  margin: -4px 0 10px;\n  color: var(--color-popup-title, #fff);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 400px;\n  height: 160px;\n\n  ", "\n  background-size: contain;\n\n  @media only screen and (max-width: 599px) {\n    width: 100%;\n    height: 130px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  padding: var(--sideSpacing);\n  background: var(--background-popup-head-image, url(", ")) center top;\n\n  min-height: 200px;\n  justify-content: center;\n  align-items: center;\n\n  @media only screen and (max-width: 599px) {\n    flex-direction: column;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border: 15px solid var(--color-popup-border, #5f5f5f);\n  background: var(--color-popup-background, #131513);\n  width: 100%;\n  z-index: 100;\n  display: block;\n  font-family: GothamPro, Arial, sans-serif;\n  font-weight: 400;\n  --sideSpacing: 50px;\n\n  @media only screen and (max-width: 767px) {\n    --sideSpacing: 30px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * In this document we used css variable:
 --color-popup-title
 --color-popup-company
 --color-popup-button-text
 --color-popup-border = #5f5f5f
 --color-popup-background = #131513
 --color-popup-track-info
 --color-brand
 --color-brand-hover
 --background-popup-head-image
 */
var PopSponsor = _styledComponents.default.div(_templateObject());

exports.PopSponsor = PopSponsor;

var PopSponsorTop = _styledComponents.default.div(_templateObject2(), _SpeakerCard.BgHeadImg);

exports.PopSponsorTop = PopSponsorTop;

var PopSponsorLogo = _styledComponents.default.div(_templateObject3(), function (_ref) {
  var src = _ref.src;
  return "\n  background: url(".concat(src, ") no-repeat center;\n    ");
});

exports.PopSponsorLogo = PopSponsorLogo;

var PopSponsorTitle = _styledComponents.default.h4(_templateObject4());

exports.PopSponsorTitle = PopSponsorTitle;

var PopSponsorBio = _styledComponents.default.div(_templateObject5());

exports.PopSponsorBio = PopSponsorBio;
var PopSponsorPerk = (0, _styledComponents.default)(PopSponsorBio)(_templateObject6());
exports.PopSponsorPerk = PopSponsorPerk;

var PopSponsorActions = _styledComponents.default.div(_templateObject7());

exports.PopSponsorActions = PopSponsorActions;

var PopButton = _styledComponents.default.a(_templateObject8());

exports.PopButton = PopButton;
var PopSponsorBtn = (0, _styledComponents.default)(PopButton)(_templateObject9(), function (_ref2) {
  var state = _ref2.state;
  return state !== _SponsorCard.buttonStates[0] && "\n    cursor: default;\n    ";
}, function (_ref3) {
  var state = _ref3.state;
  return state === _SponsorCard.buttonStates[1] && "\n    opacity: 0.5;\n    ";
});
exports.PopSponsorBtn = PopSponsorBtn;

var PopSponsorBtnDisclaimer = _styledComponents.default.div(_templateObject10());

exports.PopSponsorBtnDisclaimer = PopSponsorBtnDisclaimer;
var PopSponsorPerkBtn = (0, _styledComponents.default)(PopButton)(_templateObject11());
exports.PopSponsorPerkBtn = PopSponsorPerkBtn;

var PopSponsorMid = _styledComponents.default.div(_templateObject12(), function (_ref4) {
  var minHeight = _ref4.minHeight;
  return minHeight;
});

exports.PopSponsorMid = PopSponsorMid;